import { StackTemplate, StackType } from "../types";

/**
 * The 5 Profit Stacks with their default functions
 * Based on Network Overdrive's Profit Stacks methodology
 */
export const STACK_TEMPLATES: StackTemplate[] = [
  {
    name: "Sales",
    defaultFunctions: [
      "Lead Generation",
      "CRM & Pipeline",
      "Quoting & Proposals",
      "Contracts & Agreements",
      "Customer Onboarding",
    ],
  },
  {
    name: "People",
    defaultFunctions: [
      "Recruitment",
      "Onboarding",
      "Training & Development",
      "Performance Management",
      "HR Administration",
      "Culture & Engagement",
    ],
  },
  {
    name: "Production",
    defaultFunctions: [
      "Service Delivery",
      "Project Management",
      "Quality Assurance",
      "Documentation",
      "Support & Helpdesk",
      "Automation & Tooling",
    ],
  },
  {
    name: "Finance",
    defaultFunctions: [
      "Invoicing & Billing",
      "Accounts Receivable",
      "Accounts Payable",
      "Budgeting & Forecasting",
      "Financial Reporting",
      "Payroll",
    ],
  },
  {
    name: "Structure",
    defaultFunctions: [
      "Strategic Planning",
      "Governance & Compliance",
      "Risk Management",
      "IT Infrastructure",
      "Security & Privacy",
      "Business Continuity",
    ],
  },
];

/**
 * Stack display order
 */
export const STACK_ORDER: StackType[] = [
  "Sales",
  "People",
  "Production",
  "Finance",
  "Structure",
];

/**
 * Get default functions for a stack type
 */
export const getStackFunctions = (stackType: StackType): string[] => {
  const template = STACK_TEMPLATES.find((t) => t.name === stackType);
  return template?.defaultFunctions || [];
};
